"use client";

import React from "react";

import Base from "@/templates/Base";

import styles from "./biofresh.module.scss";

export default function PageClient() {
  const handleTrackedClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const target = event.currentTarget;
    const dataTrack = target.getAttribute("data-track");
    const ctaText = target.getAttribute("cta-text");
    const ctaLocationClass = target.getAttribute("data-cta-location-class");

    typeof window !== "undefined" &&
      typeof window.gtag === "function" &&
      window.gtag("event", "click_cta_lp", {
        cta_text: ctaText,
        cta_location_class: ctaLocationClass,
        data_track: dataTrack
      });

    document.cookie = `lastSelectPromotionName=${dataTrack};path=/;domain=.${location.hostname.replace(/^www\./i, "")}`;
  };

  return (
    <Base>
      <main className={styles.main}>
        <section className={styles.banner}>
          <div className={styles.container}>
            <div
              className={`${styles["banner-principal"]} ${styles.dobra1_banner}`}
            >
              <h1>
                Ingredientes <strong>frescos de verdade</strong>
                <br /> para quem te
                <span> ama de verdade</span>
              </h1>
            </div>
          </div>
        </section>

        <section className={styles.video}>
          <div className={styles.container}>
            <div className={styles.content}>
              <div>
                <iframe
                  className={styles["iframe-desk"]}
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/2VB-wAj947I?si=gkKjaQ1VfFYZ0e6k"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
              </div>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-icon-star.png"
                  alt="Imagem icone estrela"
                />
                <h2 className="body-text-lg">
                  Desde 2012 na categoria Super Premium Natural,{" "}
                  <strong className="subtitle-lg">
                    Biofresh é referência em alimentos verdadeiramente naturais
                  </strong>{" "}
                  e equilibrados para cães e gatos de todos os portes e em todas
                  as fases da vida.
                </h2>
                <iframe
                  className={styles["iframe-mob"]}
                  width="382"
                  height="212"
                  src="https://www.youtube.com/embed/2VB-wAj947I?si=gkKjaQ1VfFYZ0e6k"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
                <a
                  href="https://www.cobasi.com.br/pesquisa?hotsite=1221"
                  className="btn btn-md btn-orange"
                  cta-text="Confira linha completa"
                  data-cta-location-class="Primeira dobra"
                  data-track="lp-biofresh_ConfiraLinha"
                  onClick={handleTrackedClick}
                  target="_blank"
                >
                  Confira a linha completa
                </a>
              </div>
            </div>
            <div className={styles.wrapper}>
              <div className={styles.group}>
                <div className={styles.box}>
                  <strong className="body-text-lg">100% natural</strong>
                  <p className="body-text-lg">
                    livre de corantes, aromatizantes e conservantes artificiais
                  </p>
                </div>
                <div className={`${styles.box} ${styles.box2}`}>
                  <strong className="body-text-lg">
                    Alta inclusão de ingredientes frescos
                  </strong>
                  <p className="body-text-lg">
                    carnes, frutas, vegetais e ervas da mais alta qualidade
                  </p>
                </div>
                <div className={`${styles.box} ${styles.box3}`}>
                  <strong className="body-text-lg">
                    Tecnologia inovadora de atmosfera controlada combinada ao
                    extrato de alecrim e a vitamina E
                  </strong>
                  <p className="body-text-lg">
                    preserva a crocância do alimento de forma saudável e
                    saborosa até a hora do consumo
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.beneficios}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h2 className="heading-md">
                Benefícios comprovados para a saúde do seu pet
              </h2>
              <p className="body-text-lg">
                Alimentação pensada para quem você ama
              </p>
            </div>
            <div className={styles.content}>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-benefits-paladar.png"
                  alt="Imagem paladares"
                />
                <p className="body-text-lg">
                  Atende
                  <br />
                  <strong className="subtitle-lg">paladares exigentes</strong>
                </p>
              </div>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-benefits-saude-intestinal.png"
                  alt="Imagem intestino"
                />
                <p className="body-text-lg">
                  Auxilia no equilíbrio da{" "}
                  <strong className="subtitle-lg"> saúde intestinal</strong>
                </p>
              </div>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-benefits-pelagem.png"
                  alt="Imagem pelagem"
                />
                <p className="body-text-lg">
                  Contribui com o<br />
                  <strong className="subtitle-lg"> brilho da pelagem</strong>
                </p>
              </div>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-benefits-saude-oral.png"
                  alt="Imagem pelagem"
                />
                <p className="body-text-lg">
                  Cuida da
                  <br />
                  <strong className="subtitle-lg"> saúde oral</strong>
                </p>
              </div>
              <div>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-benefits-articulacoes.png"
                  alt="Imagem pelagem"
                />
                <p className="body-text-lg">
                  Contribui com a saúde das
                  <strong className="subtitle-lg"> articulações</strong>
                </p>
              </div>
            </div>
            <div className={styles.photos}>
              <img
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-cachorro-comendo.png"
                alt="Imagem de cachorro comendo"
              />
              <img
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-gato-comendo.png"
                alt="Imagem de gato comendo"
              />
            </div>
            <a
              className="btn btn-md btn-orange"
              href="https://www.cobasi.com.br/pesquisa?hotsite=1221"
              target="_blank"
              cta-text="Confira linha completa"
              data-cta-location-class="Segunda dobra"
              data-track="lp-biofresh_Confira-linha-completa"
              onClick={handleTrackedClick}
            >
              Confira a linha completa
            </a>
          </div>
        </section>

        <section className={styles.premium}>
          <div className={styles.container}>
            <div className={styles.content}>
              <h3>
                O alimento super premium natural que{" "}
                <span>seu pet merece,</span> os ingredientes que{" "}
                <span>ele precisa</span>
              </h3>
              <div className={styles.wrapper}>
                <div className={styles.box}>
                  <p>Ervas</p>
                  <p>Maçã</p>
                  <p>Frutas</p>
                </div>
                <div className={styles.box}>
                  <p>Lombo</p>
                  <p>Mamão</p>
                  <p>Salmão</p>
                </div>
                <div className={styles.box}>
                  <p>Abacaxi</p>
                  <p>Orégano</p>
                  <p>Legumes</p>
                </div>
                <div className={styles.box}>
                  <p>Beterraba</p>
                  <p>Peixe branco</p>
                </div>
                <div className={styles.box}>
                  <p>Peito de frango</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.quantity}>
          <div className={styles.container}>
            <div className={styles.content}>
              <img
                className={styles["photo-mob"]}
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-bio-fresh-2026-pote-racao.png"
                alt="Imagem pote de ração"
              />
              <img
                className={styles["photo-desk"]}
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-photo-racao-biofresh-desk-new.png"
                alt="Imagem de ração"
              />
              <img
                className={styles["photo-mob2"]}
                src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-photo-racao-biofresh-mob-new.png"
                alt="Imagem de ração"
              />

              <div className={styles.text}>
                <h3 className="heading-md">
                  Qual a quantidade ideal
                  <br /> de ração para o seu pet?
                </h3>
                <p className="body-text-lg">
                  Para uma vida longa e saudável, é importante encontrar
                  equilíbrio na porção de alimento oferecida.
                </p>
                <span className="subtitle-lg">
                  Descubra a dosagem recomendada para seu pet
                </span>
                <a
                  className="btn btn-md btn-orange"
                  href="https://www.biofreshpet.com.br/pt/quantidade-diaria"
                  target="_blank"
                  cta-text="Saiba Mais"
                  data-cta-location-class="Terceira dobra"
                  data-track="lp-biofresh_Saiba-mais"
                  onClick={handleTrackedClick}
                >
                  Saiba mais
                </a>
                <img
                  className={styles.photo}
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-bio-fresh-2026-pote-racao.png"
                  alt="Imagem pote de ração"
                />
              </div>
            </div>
          </div>
        </section>

        <section className={styles.transicao}>
          <div className={styles.content}>
            <div className={styles.container}>
              <h3 className="heading-lg">
                Como fazer a transição de outra ração para a Biofresh?
              </h3>
            </div>
          </div>
          <div>
            <a
              className="btn btn-lg btn-orange"
              href="https://www.cobasi.com.br/pesquisa?hotsite=1221"
              target="_blank"
              cta-text="Confira linha completa"
              data-cta-location-class="Quarta dobra"
              data-track="lp-biofresh_Linha-completa"
              onClick={handleTrackedClick}
            >
              Confira a linha completa
            </a>
          </div>
        </section>

        <section className={styles.pet}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h3 className="heading-md">
                Agora que você já conhece a Biofresh, é hora de escolher a que
                mais se adequa às exigências do seu pet
              </h3>
            </div>
            <div className={styles.content}>
              <div className={styles.card}>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-photo-cao-comendo-new2.png"
                  alt="Imagem de cachorro"
                />
                <a
                  className="btn btn-md btn-orange"
                  href="https://www.cobasi.com.br/pesquisa?hotsite=1222"
                  target="_blank"
                  cta-text="Confira produtos cães"
                  data-cta-location-class="Quarta dobra"
                  data-track="lp-biofresh_Confira-produtos-caes"
                  onClick={handleTrackedClick}
                >
                  Confira produtos
                </a>
              </div>
              <div className={styles.card}>
                <img
                  src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/lp-biofresh-2026-photo-gato-comendo-new2.png"
                  alt="Imagem de gato"
                />
                <a
                  className={`btn btn-md btn-orange ${styles.cat}`}
                  href="https://www.cobasi.com.br/pesquisa?hotsite=913"
                  target="_blank"
                  cta-text="Confira produtos gatos"
                  data-cta-location-class="Quarta dobra"
                  data-track="lp-biofresh_Confira-produtos-gatos"
                  onClick={handleTrackedClick}
                >
                  Confira produtos
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </Base>
  );
}
